import { VideoPlayer } from "@modules/common/media/components/videoPlayer"
import { word } from "@modules/core/utils/i18n"
import { MediaItemFormikType } from "@modules/sessionBlock/media/mediaFormikTypes"
import { HUText } from "@modules/ui/components/huText"
import { ComponentProps } from "react"

type MediaExistingBlockVideoProps = {
  media: MediaItemFormikType
} & ComponentProps<"div">

export function MediaExistingBlockVideo({ media, ...props }: MediaExistingBlockVideoProps) {
  const source = media.file
    ? {
        src: URL.createObjectURL(media.file),
        type: media.file.type === "video/quicktime" ? "video/mp4" : media.file.type,
      }
    : {
        src: media.url,
        type: "application/x-mpegURL",
      }

  return (
    <div className="flex flex-row align-items-center gap-3 overflow-hidden" {...props}>
      {media.url || media.file ? (
        <VideoPlayer
          options={{
            autoplay: false,
            controls: true,
            experimentalSvgIcons: true,
            sources: [source],
          }}
          size="extrasmall"
          className="rounded-big-radius overflow-hidden min-w-min"
        />
      ) : (
        <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }}>
          {word("sessionForm.blocks.add_media.missing_error")}
        </HUText>
      )}
      <HUText fontStyle="BM" className="text-overflow-ellipsis overflow-hidden">
        {media.filename}
      </HUText>
    </div>
  )
}
